import React from 'react';
import { browserHistory, Link } from 'react-router';
import classnames from 'classnames';

import './Wrapper.scss';
import Spinner from '../../../../../../components/Spinner';

class Wrapper extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      UserCurrentValues: {},
      error: null,
      loading: false,
      deleted: [],
      processingDelete: null,
    };

    this.renderJobPositions = this.renderJobPositions.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentWillReceiveProps (nextProps) { // Redirect if no company
    if (nextProps.authenticatedID === null) {
      browserHistory.push('/company/');
    }

    if (nextProps.CompanyData.loading === false) {
      if (nextProps.CompanyData.Companies.length === 0) {
        browserHistory.push('/company/create');
      }
    }
  }

  componentDidMount () {
    if (this.props.authenticatedID === null) {
      browserHistory.push('/company');
    }
  }

  handleDelete (JobID) {
    const self = this;
    return () => {
      console.log('Attempt to delete: ', JobID);
      if (self.state.processingDelete === null) {
        this.setState({
          processingDelete: JobID,
        });

        return self.props.deleteOpenPosition({
          variables: {
            JobID,
          }
        }).then(deleted => {
          let currentDeleted = self.state.deleted || [];
          currentDeleted.push(JobID);
          self.setState({
            processingDelete: null,
            deleted: currentDeleted,
          });
        });
      }
    };
  }

  renderJobPositions () {
    if (this.props.CompanyData.loading === false) {
      if (this.props.CompanyData.Companies.length > 0) {
        const CompanyData = this.props.CompanyData.Companies[0];
        const JobStatusKey = {
          'full_time': 'Full Time',
          'part_time': 'Part Time',
          'contractor': 'Contractor',
        };

        const reverseArr = input => {
          let ret = [];
          for (let i = input.length - 1; i >= 0; i--) {
            ret.push(input[i]);
          }
          return ret;
        };

        if ((CompanyData.Jobs.length - this.state.deleted.length) === 0) {
          return (
            <div>
              <br />
              <p>You do not currently have any Job Openings.  Click below to create one now!</p>
            </div>
          );
        }

        return reverseArr(CompanyData.Jobs).map((JobData, JobIndex) => (
          <div className={classnames({
            'JobEntry__Wrapper': true,
            'JobEntry__Wrapper--deleted': this.state.deleted.includes(JobData.id),
          })} key={JobData.id}>
            {
              (this.state.processingDelete === JobData.id)
              ? <div className='JobEntry__Overlay'><Spinner style={{ margin: '50px auto' }} /></div>
              : null
            }
            <div className='row'>
              <div className='col-sm-9 col-md-10'>
                <h5>{JobData.title}</h5>
                <h6>{JobStatusKey[(JobData.job_time_status)]}</h6>
                <p>{(JobData.description || 'No Description Provided').substr(0, 200)}</p>
              </div>
              <div className='col-sm-3 col-md-2'>
                <Link to={'/company/jobs/update/' + JobData.id} className='button button--primary'>Edit</Link>
                <span onClick={this.handleDelete(JobData.id)} className='button button--negative'>Delete</span>
              </div>
            </div>
          </div>
        ));
      }
    }

    return (
      <Spinner style={{ marginTop: '50px', marginBottom: '50px' }} />
    );
  }

  render () {
    if (this.props.authenticatedID !== null) {
      return (
        <div className='JobList__Wrapper'>
          <div className='row'>
            <div className='col'>
              <h2 className='JobList__Title'>Your Job Openings</h2>
            </div>
          </div>
          {this.renderJobPositions()}
          <div className='row' style={{ marginTop: '25px' }}>
            <div className='col'>
              <Link to='/company/jobs/create' className='button button--positive JobList__CreatePositionButton'>Add New Job Opening</Link>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

export default Wrapper;



// WEBPACK FOOTER //
// ./src/routes/company/routes/Jobs/components/Wrapper/index.js